// Central date/time formatting — everything displayed in IST (Asia/Kolkata) 12-hour format.
const IST = "Asia/Kolkata";
const LOCALE = "en-IN";

export function fmtTimeIST(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleTimeString(LOCALE, {
    hour: "2-digit", minute: "2-digit", hour12: true, timeZone: IST,
  });
}

export function fmtDateTimeIST(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(LOCALE, {
    day: "2-digit", month: "short", year: "numeric",
    hour: "2-digit", minute: "2-digit", hour12: true,
    timeZone: IST,
  });
}

export function fmtDateShortIST(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(LOCALE, {
    day: "2-digit", month: "short",
    hour: "2-digit", minute: "2-digit", hour12: true,
    timeZone: IST,
  });
}

export function fmtDateOnlyIST(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString(LOCALE, {
    day: "2-digit", month: "short", year: "numeric",
    timeZone: IST,
  });
}

export function fmtLiveClockIST(dateOrMs) {
  const d = typeof dateOrMs === "number" ? new Date(dateOrMs) : dateOrMs;
  return d.toLocaleTimeString(LOCALE, {
    hour: "2-digit", minute: "2-digit", second: "2-digit", hour12: true, timeZone: IST,
  });
}
